// extracted by css-extract-rspack-plugin
export default {"settingsAccordion":"settingsAccordion-QmHJ28"};